import { createCachedSelector, DuckSelector } from '@atc/modular-redux';

import { resultsDuckCreator } from 'axl-ducks';

import { srpDuckPreset } from '@/ducks/presets/index.js';

export default resultsDuckCreator({
    ...srpDuckPreset,
    store: 'spotlight',
    initialState: {
        activeResults: [],
        spotlightTypes: [],
    },
}).extend({
    types: [
        'SET_SPOTLIGHT_TYPES',
    ],
    reducer: (state, action, { types }) => {
        switch (action.type) {
            case types.SET_SPOTLIGHT_TYPES: {
                const { spotlightTypes, append } = action.payload;

                const currentSpotlightTypes = state.spotlightTypes || [];

                if (append) {
                    return {
                        ...state,
                        spotlightTypes: [
                            ...currentSpotlightTypes,
                            spotlightTypes,
                        ],
                    };
                }

                return {
                    ...state,
                    spotlightTypes: [
                        spotlightTypes,
                    ],
                };
            }

            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        setSpotlightTypes: (spotlightTypes, append = true) => ({
            type: types.SET_SPOTLIGHT_TYPES,
            payload: {
                spotlightTypes,
                append,
            },
        }),
    }),
    selectors: () => ({
        getIndividualSpotlight: new DuckSelector((selectors) => createCachedSelector(
            selectors.getActiveInventory,
            (state, listingId) => listingId,
            (activeInventory, listingId) => {
                const inventory = activeInventory || [];
                return inventory.find((item) => item?.id === listingId);
            }
        )((state, listingId) => listingId || 'default')),
        getSpotlightTypes: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).spotlightTypes || []),
    }),
});
